export enum AiFilterGender {
  BOY = "boy",
  GIRL = "girl",
  MAN = "man",
  WOMAN = "woman",
}

export enum AspectRatio {
  ratio16x9 = "16x9",
  ratio1x1 = "1x1",
  ratio9x16 = "9x16",
  ratio4x3 = "4x3",
  ratio3x4 = "3x4",
}

export type AiFilterType = {
  id: string;
  name: string;
  isGroup: boolean;
  previews: AiFilterPreviewType[];
};

export type AiFilterPreviewType = {
  gender: AiFilterGender;
  aspectRatio: AspectRatio;
  url: string;
  thumbnailUrl: string;
};

export type AiFilterItemType = {
  id: string;
  name: string;
  url: string;
  thumbnail: string;
  width: number;
  height: number;
  isVideo?: boolean;
  filterType?: number;
};
